export default function getColumnType (columnName) {
  const columnType = {
    Alphanumeric: 'string',
    Numeric: 'number',
    Date: 'date',
    Currency: 'string',
  };
  return columnType[columnName] || null;
//   return columnType[columnName] || 'string';
};